import { render, staticRenderFns } from "./followDialog.vue?vue&type=template&id=7090f49c&"
import script from "./followDialog.vue?vue&type=script&lang=js&"
export * from "./followDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports